import invoiceService from "./InvoiceService";

const inflight = new Map<string, Promise<{ data: unknown }>>();

/** One status request per type+transactionId at a time — avoids race that flips PAID → FAILED. */
export function getPaymentStatusDeduped(
  type: string,
  transactionId: string
): Promise<{ data: unknown }> {
  const key = `${type}:${transactionId}`;
  const existing = inflight.get(key);
  if (existing) return existing;

  const request = invoiceService
    .getStatusDetailsData(type, transactionId, { silent: true })
    .finally(() => {
      inflight.delete(key);
    });

  inflight.set(key, request);
  return request;
}
